import theme from '../../muiTheme';

const styles = {
      cardAction: {
        display: 'block',
        textAlign: 'initial',
        minHeight: '250px', 
        transition: '300ms', 
        [theme.breakpoints.down('sm')]: {
          border: '0px solid transparent',
          minHeight: '200px'
        }
      },
      mediaOverlay: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'flex-start',
        position: 'absolute',
        top: '20px',
        left: '20px',
        color: 'white'
      },
      userAvatar: {
        borderRadius: '60px',
        width: '60px',
        height: '60px',
        backgroundColor: 'black',
        border: '1px solid white',
        boxSizing: 'content-box'
      },
      userInfo: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start',
        marginLeft: '10px'
      },
      userName: {
        backgroundColor: '#0000004d',
        padding: '2px 10px',
        margin: '3px',
        borderRadius: '20px'
        
      },
      createdAt: {
        backgroundColor: '#0000004d',
        padding: '2px 10px',
        margin: '3px',
        borderRadius: '20px'
      },
      tagContainer: {
        display: 'inline-flex',
        flexDirection: 'row',
        justifyContent: 'flex-start',
        flexWrap: 'wrap',
        margin: '15px 10px'
      },
      postTag: {
        padding: '5px 12px',
        margin: '3px 4px',
        borderRadius: '20px',
        transition: '0.3s',
        cursor: 'pointer',
        backgroundColor: theme.palette.faint,
        '&:hover, &:active, &:focus': {
          backgroundColor: theme.palette.primary.main,
          color: 'white'
        }
      }

}

export default styles; 